import { render, staticRenderFns } from "./PageRouterView.vue?vue&type=template&id=3e39144b&scoped=true&"
import script from "./PageRouterView.vue?vue&type=script&lang=js&"
export * from "./PageRouterView.vue?vue&type=script&lang=js&"
import style0 from "./PageRouterView.vue?vue&type=style&index=0&id=3e39144b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e39144b",
  null
  
)

export default component.exports